import { Injectable } from '@angular/core';
import { HomeService } from '../../home/home.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resturlConstants } from '../../../rest-url/resturlconstants';
import { environment } from '../../../environments/environment';

@Injectable()
export class GoldLoansService {
  constructor(private http: HttpClient, private homeService: HomeService) { }

  getGDLSummary(): Observable<any> {
    return this.http.post<any>(resturlConstants.gdlLoanUrl, {
      'userId': localStorage.getItem('userId'),
      'clientShortCode': environment.clientShortCode
    },
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json')
          .set('Authorization', this.homeService.getAuthHeader())
      });

  }
}
